import { difference, forEach, map, mapValues, pick, omit, without, compact } from "lodash"

import ActionTypes from "../../enums/ActionTypes"
import { initialState } from "./initialState"
import { adjustOrderPosition, adjustProductionOrder, cloneStore } from "./helpers/helpers"

export default (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.PLANNING_OBJECTS_DELETE_SUCCESS: {
      const {
        activities: deletedActivities,
        operations: deletedOperations,
        orderPositions: deletedOrderPositions,
        productionOrders: deletedProductionOrders,
        projects: deletedProjects,
        updatedAttendantOperations = [],
      } = action.payload

      const nextState = cloneStore(state)

      nextState.operations = omit(nextState.operations, deletedOperations)
      nextState.productionOrders = omit(nextState.productionOrders, deletedProductionOrders)
      nextState.productionOrders = mapValues(nextState.productionOrders, productionOrder => ({
        ...productionOrder,
        operations: without(productionOrder.operations, ...deletedOperations),
      }))
      nextState.activities = omit(nextState.activities, deletedActivities)
      nextState.activities = mapValues(nextState.activities, activity => ({
        ...activity,
        productionOrders: without(activity.productionOrders, ...deletedProductionOrders),
      }))
      nextState.orderPositions = omit(nextState.orderPositions, deletedOrderPositions)
      nextState.orderPositions = mapValues(nextState.orderPositions, orderPosition => ({
        ...orderPosition,
        activities: without(orderPosition.activities, ...deletedActivities),
      }))
      nextState.projects = omit(nextState.projects, deletedProjects)
      nextState.projects = mapValues(nextState.projects, project => ({
        ...project,
        orderPositions: without(project.orderPositions, ...deletedOrderPositions),
      }))

      forEach(updatedAttendantOperations, att => {
        const existing = nextState.operations[att.operationId]
        if (!existing) return

        nextState.operations[att.operationId] = {
          ...existing,
          startDate: att.startDate,
          endDate: att.endDate,
        }
      })

      let orderPositionsToAdjust = map(pick(state.activities, deletedActivities), "orderPositionId")

      let productionOrdersToAdjust = compact(map(pick(state.operations, deletedOperations), "productionOrderId"))

      const attendantPOs = compact(
        map(updatedAttendantOperations, att => {
          const op = state.operations[att.operationId]
          return op?.productionOrderId
        })
      )

      productionOrdersToAdjust = productionOrdersToAdjust.concat(attendantPOs)

      orderPositionsToAdjust = difference(orderPositionsToAdjust, deletedOrderPositions)
      productionOrdersToAdjust = difference(productionOrdersToAdjust, deletedProductionOrders)
      forEach(orderPositionsToAdjust, orderPositionId => adjustOrderPosition(nextState, orderPositionId))
      forEach(productionOrdersToAdjust, productionOrderId => adjustProductionOrder(nextState, productionOrderId))
      return nextState
    }
    default:
      return state
  }
}
